import { Helmet } from 'react-helmet-async';
import TransitionView from '../../../components/dashboard/transitions/Transition/TransitionView';
import { TransitionViewProvider } from '../../../components/dashboard/transitions/Transition/_TransitionViewContext';

export default function TransitionForm() {
  return (
    <>
      <Helmet>
        <title> Transition Form | Platform Solutions</title>
      </Helmet>
      <TransitionViewProvider>
        <TransitionView />
      </TransitionViewProvider>
    </>
  );
}
